module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-02-fe73c4a21708278562938e43ccc97248.jpg";